import React, { useEffect, useState } from 'react';

import {
  getCdnUrl,
  getSvgContent,
  rallyIconContent,
} from '@rally/energon-utilities';

import { IconProps } from './Icon.interface';
import localIcons from './localIcons';

export const RDS_ICON = 'rds-icon';

const getIconClasses = (
  name?: string,
  size?: string,
  className?: string,
): string =>
  [RDS_ICON, name || '', size ? `${RDS_ICON}-${size}` : '', className].join(
    ' ',
  );

const RdsIcon = React.forwardRef<
  HTMLSpanElement, // The reference type - which element the final ref is attached to.
  IconProps
>(({ className, env = 'prod', name, size, ...spanProps }, forwardedRef) => {
  const iconClasses = getIconClasses(name, size, className);
  const [loadedIcon, setLoadedIcon] = useState('');

  useEffect(() => {
    if (name) {
      // Use built-in icons before trying to load icons from an external url.
      if (localIcons[name]) {
        setLoadedIcon(localIcons[name]);
        return;
      }

      const url = getCdnUrl(name, env);
      // iconContent can be an svg | '' | undefined. It will be cached as empty string if a previous request for that icon failed.
      // This precludes the use of rallyIconContent's map `has` method, since it will return true for an empty string.
      const iconContent = rallyIconContent.get(url);

      if (iconContent) {
        // synchronous
        setLoadedIcon(iconContent);
      } else {
        // retrieve svg from CDN
        getSvgContent(url).then((svg) => {
          setLoadedIcon(svg ? svg : '');
        });
      }
    }
  }, [env, name]);

  // Spans are used here for sizing the SVG and for being able to inject the SVG contents from the CDN
  // TODO: explore decoupling the svg itself from the outer contents: https://jira.rallyhealth.com/browse/UCRON-1455
  return name ? (
    <span ref={forwardedRef} {...spanProps} className={iconClasses}>
      {/* eslint-disable */}
      <span dangerouslySetInnerHTML={{ __html: loadedIcon }}></span>
    </span>
  ) : null;
});

export default RdsIcon;
